// src/features/media/useClipMutation.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MediaApi } from './MediaApi';
import { MEDIA_QUERY_KEYS } from '@/lib/constants/media';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { ClipCreateRequest, VideoViewData } from '@/lib/types/Media';

interface ClipParams {
  mediaId: number;
  req: ClipCreateRequest;
}

/**
 * Mutation hook for creating video clips.
 * Handles cache updates on success.
 */
export function useClipMutation() {
  const { selectedCId } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ mediaId, req }: ClipParams) =>
      MediaApi.createClip(selectedCId!, mediaId, req),
    onSuccess: (newVideo: VideoViewData) => {
      // Add new video to detail cache
      queryClient.setQueryData(
        MEDIA_QUERY_KEYS.video(selectedCId!, newVideo.media.mediaId),
        newVideo
      );
      // Invalidate list to include new clip
      queryClient.invalidateQueries({
        queryKey: MEDIA_QUERY_KEYS.videos(selectedCId!),
      });
    },
  });
}
